export default __webpack_public_path__ + "static/media/chole3x.16963949.png";